<template>
    <div class="jobManagement">
        <div class="tableCont">
            <div class="tabCont">
                <el-tabs
                    v-model="searchForm.status"
                    type="border-card"
                    @tab-click="job"
                    ref="tabs"
                >
                    <el-tab-pane
                        v-for="item in statusList"
                        :key="item.status"
                        :name="item.status"
                    >
                        <span slot="label" class="label"
                            ><!-- <i class="el-icon-box"></i> -->{{
                                item.name
                            }}
                            {{ item.total }}</span
                        >
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-drawer
                title="高级搜索"
                :visible.sync="drawerVisible"
                size="320px"
                class="drawerCont"
                ref="drawer"
                :wrapperClosable="false"
            >
                <el-scrollbar class="scrollbar">
                    <el-form
                        :model="searchForm"
                        label-width="120"
                        class="drawerForm"
                    >
                        <el-form-item label="任务标题" size="small">
                            <el-input
                                clearable
                                placeholder="请输入任务标题"
                                size="small"
                                v-model="searchForm.title"
                                @keydown.enter.native="job"
                                @clear="job"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="项目名称" size="small">
                            <el-select
                                v-model="searchForm.project_id"
                                filterable
                                placeholder="请选择项目名称"
                                clearable
                                @change="projectTeam"
                                @clear="projectClear"
                            >
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="指派人" size="small">
                            <el-select
                                v-model="appointor"
                                filterable
                                multiple
                                clearable
                                placeholder="请选择指派人"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="优先级" size="small">
                            <el-select
                                v-model="searchForm.priority"
                                placeholder="请选择优先级"
                                clearable
                                @change="job"
                            >
                                <el-option
                                    :label="i"
                                    :value="i"
                                    v-for="i in 5"
                                    :key="i"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="text-align: right">
                            <el-button
                                type="danger"
                                icon="el-icon-refresh-right"
                                size="small"
                                @click="clean"
                            >
                                重置条件
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <div class="drawer-footer">
                    <el-button
                        style="width: 100%"
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        @click="job(1)"
                    >
                        查询
                    </el-button>
                    <!-- <el-button
                        type="danger"
                        icon="el-icon-circle-close"
                        size="small"
                        @click="clean"
                    >
                        清空
                    </el-button> -->
                </div>
            </el-drawer>
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                    >
                        <el-form-item label="任务标题" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入任务标题"
                                size="mini"
                                v-model="searchForm.title"
                                @keydown.enter.native="job"
                                @clear="job"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="项目名称" size="mini">
                            <!-- <el-input
                                clearable
                                placeholder="请输入项目名称"
                                size="mini"
                                v-model="searchForm.project_name"
                            >
                            </el-input> -->
                            <el-select
                                v-model="searchForm.project_id"
                                filterable
                                placeholder="请选择项目名称"
                                clearable
                                @change="projectTeam"
                                @clear="projectClear"
                            >
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="优先级" size="mini">
                            <el-select
                                v-model="searchForm.priority"
                                placeholder="请选择优先级"
                                clearable
                                @change="job"
                            >
                                <el-option
                                    :label="i"
                                    :value="i"
                                    v-for="i in 5"
                                    :key="i"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="job(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <template v-for="item in menuAuth.slice(0, 2)">
                            <el-button
                                type="primary"
                                :key="item.id"
                                :icon="item.icon"
                                size="mini"
                                @click="authFunc(item.funcName)"
                            >
                                {{ item.name }}
                            </el-button>
                        </template>
                        <el-dropdown
                            v-if="menuAuth.length > 2"
                            @command="authFunc"
                            style="margin-left: 10px"
                        >
                            <el-button
                                type="primary"
                                size="mini"
                                icon="el-icon-arrow-down"
                            >
                                更多操作
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    :key="item.id"
                                    v-for="item in menuAuth.slice(2)"
                                    :command="item.funcName"
                                >
                                    <i :class="item.icon"> </i>
                                    {{ item.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div v-else></div>
                </div>
                <!-- 高级搜索 -->
                <advancedSearch :drawerVisible.sync="drawerVisible"
                    >高级搜索</advancedSearch
                >
            </div>

            <div class="table" :style="{ height: $store.state.index.screen }">
                <el-table
                    :data="tableData"
                    ref="tableData"
                    v-loading="loading"
                    highlight-current-row
                    height="100%"
                    @selection-change="handleSelectionChange"
                    @sort-change="sortChange"
                >
                    <el-table-column
                        type="selection"
                        align="center"
                        :fixed="checkFixed"
                    >
                    </el-table-column>
                    <el-table-column
                        label="任务ID"
                        property="id"
                        align="left"
                        sortable
                        width="85"
                        fixed
                    >
                    </el-table-column>
                    <el-table-column
                        label="优先级"
                        property="priority"
                        align="left"
                        width="90"
                        sortable
                        fixed
                    >
                        <template slot-scope="scope">
                            <p
                                class="priority"
                                :class="[
                                    scope.row.priority == 1
                                        ? 'priority1'
                                        : scope.row.priority == 2
                                        ? 'priority2'
                                        : scope.row.priority == 3
                                        ? 'priority3'
                                        : scope.row.priority == 4
                                        ? 'priority4'
                                        : '',
                                ]"
                            >
                                {{ scope.row.priority }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="任务标题"
                        property="title"
                        align="left"
                        width="300"
                        fixed
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="项目名称"
                        property="project_name"
                        align="left"
                        width="140"
                        fixed
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="开始时间"
                        property="start_time"
                        align="left"
                        width="120"
                    >
                    </el-table-column>
                    <el-table-column
                        label="预计完成时间"
                        property="end_time"
                        align="left"
                        width="120"
                    >
                    </el-table-column>
                    <el-table-column
                        label="完成时间"
                        property="complete_time"
                        align="left"
                        width="140"
                    >
                    </el-table-column>

                    <el-table-column label="当前状态" align="left" width="80">
                        <template slot-scope="scope">
                            <el-tag
                                size="mini"
                                :type="
                                    scope.row.status == 1
                                        ? 'info'
                                        : scope.row.status == 5
                                        ? 'warning'
                                        : scope.row.status == 10 ||
                                          scope.row.status == 20
                                        ? 'success'
                                        : scope.row.status == 99
                                        ? 'danger'
                                        : ''
                                "
                            >
                                {{ scope.row.status_cn }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="总耗时"
                        property="total_time"
                        align="left"
                        width="80"
                    >
                    </el-table-column>
                    <el-table-column
                        label="指派人"
                        property="appointor_cn"
                        align="left"
                        width="100"
                    >
                        <template slot-scope="scope">
                            <div class="nameCont">
                            <div class="headImg" >
                                <el-avatar v-if="scope.row.appointor_avatar!=''"
                                        size="small"
                                        :src="scope.row.appointor_avatar"
                                ></el-avatar>
                                <span v-else>
                                <el-avatar
                                    size="small"
                                    :src="'https://uc-api.loratech.cn/dingtalk/2/user/'+encodeURIComponent(scope.row.appointor_cn)+'/avatar/50'"
                                ></el-avatar>
                                </span>
                            </div>
                            <div class="memberName">
                                {{ scope.row.appointor_cn }}
                            </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        property="user_name"
                        align="left"
                        width="100"
                    >
                      <template slot-scope="scope">
                        <div class="nameCont">
                          <div class="headImg" >
                            <el-avatar v-if="scope.row.user_avatar!=''"
                                       size="small"
                                       :src="scope.row.user_avatar"
                            ></el-avatar>
                            <span v-else>
                    <el-avatar
                        size="small"
                        :src="'https://uc-api.loratech.cn/dingtalk/2/user/'+encodeURIComponent(scope.row.user_name)+'/avatar/50'"
                    ></el-avatar></span>

                          </div>
                          <div class="memberName">
                            {{ scope.row.user_name }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="创建时间"
                        property="create_time"
                        align="left"
                        sortable
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        label="操作"
                        align="left"
                        width="120"
                        :fixed="operationFixed"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.authority && scope.row.authority.length <= 3">
                                <div class="operation-btns">
                                    <span
                                        v-for="item in scope.row.authority"
                                        :key="item.id"
                                    >
                                        <el-button
                                            v-if="
                                                item.status_flag != 2 &&
                                                item.status_flag != 4
                                            "
                                            type="text"
                                            size="small"
                                            class="color-blue"
                                            @click="rowDo(scope.row, item)"
                                            >{{ item.name }}</el-button
                                        >
                                        <el-popover
                                            v-else-if="item.name == '完成'"
                                            placement="right"
                                            width="400"
                                            trigger="click"
                                            @show="popoverShow(scope.row.id)"
                                        >
                                            <jobComplete
                                                :totalTime="total_time"
                                                :completeVisible.sync="completeVisible"
                                                :tableItem="scope.row"
                                            ></jobComplete>
                                            <el-button
                                                slot="reference"
                                                type="text"
                                                size="small"
                                                >{{ item.name }}</el-button
                                            >
                                        </el-popover>
                                        <popConfirm
                                            v-else-if="item.status_flag == 4"
                                            :title="item.name"
                                            :buttonText="item.name"
                                            @confirm="rowDo(scope.row, item)"
                                        >
                                        </popConfirm>
                                    </span>
                                </div>
                            </span>
                            <span v-else>
                              <span style="margin-right: 2px;"
                                  v-for="item in scope.row.authority"
                                  :key="item.id"
                              >
                                    <el-button
                                        v-if="item.status_flag != 4 && item.name=='查看'"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        @click="rowDo(scope.row, item)"
                                    >{{ item.name }}</el-button
                                    >
                                </span>

                            <el-dropdown size="small">
                                <span  style="-webkit-text-fill-color:#eb5202;">
                                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <template v-for="(item, index) in scope.row.authority.filter(item => !['查看'].includes(item.name))" >
                                        <span style="-webkit-text-fill-color:#eb5202;" :key="index" v-if=" item.name!='完成'"  @click="rowDo(scope.row, item)">
                                            <el-dropdown-item >{{ item.name }}</el-dropdown-item>
                                        </span>
                                        <span style="-webkit-text-fill-color:#eb5202;" :key="index" v-else-if="item.name='完成'">
                                                
                                            <el-popover
                                                placement="right"
                                                width="400"
                                                trigger="click"
                                                @show="popoverShow(scope.row.id)"
                                            >
                                            <jobComplete
                                                :totalTime="total_time"
                                                :completeVisible.sync="completeVisible"
                                                :tableItem="scope.row"
                                            ></jobComplete>
                                           
                                            <el-dropdown-item slot="reference"
                                                type="text"
                                                size="small">{{ item.name }}</el-dropdown-item>
                                        </el-popover>
                                        </span>
                                       
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>

            <jobAdd :addVisible.sync="addVisible"></jobAdd>
            <jobEdit
                :editVisible.sync="editVisible"
                :tableItem="tableItem"
            ></jobEdit>
            <jobDetail
                :detailVisible.sync="detailVisible"
                :tableItem="tableItem"
            ></jobDetail>
            <!-- <jobComplete
                :completeVisible.sync="completeVisible"
                :tableItem="tableItem"
            ></jobComplete> -->
        </div>
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import pagination from "@/comon/components/pagination";
import advancedSearch from "@/comon/components/advancedSearch";
import popConfirm from "@/comon/components/popConfirm";

export default {
    mixins: [tableMixin],
    data() {
        return {
            searchForm: {
                title: "",
                priority: "",
                status: "0",
                project_id: "",
                appointor: "",
            },
            menuId: "",
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },

            tableItem: [],
            detailVisible: false,
            addVisible: false,

            selectionUserIdList: [],

            drawerVisible: false,
            editVisible: false,
            appointor: [],
            statusList: [],
            staffList: [],
            projectList: [],
            completeVisible: false,
            orderby_id: null,
            orderby_create_time: null,
            orderby_priority: null,
            activeIndex: null,
            total_time: "", //指派人总耗时
        };
    },
    methods: {
        detail(row) {
            //console.log(row);
            this.tableItem = row;
            this.detailVisible = true;
        },
        add() {
            this.addVisible = true;
        },

        clean() {
            this.appointor = [];
            this.searchForm = {
                title: "",
                priority: "",
                status: "0",
                project_id: "",
                appointor: "",
            };
            this.job();
        },
        export() {
            oaApi.interviewBatchExport().then((res) => {
                if (res) {
                    window.open(res.data.url);
                }
            });
        },
        /**
         * 批量删除
         */
        batchDel() {
            if (this.selectionUserIdList.length > 0) {
                this.$confirm("是否批量删除选中的数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        oaApi
                            .eventsBatchDelete({
                                ids: this.selectionUserIdList.toString(),
                            })
                            .then((res) => {
                                //console.log(res);
                                if (res.code == 200) {
                                    this.$message.success("删除成功！");
                                    this.job();
                                } else {
                                    this.$message.error("删除失败！");
                                }
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            } else {
                this.$message.warning("请勾选要删除的数据");
            }
        },
        closeDrawer() {
            this.drawerVisible = false;
        },
        /**
         * 获取任务列表
         */
        job(page, payload, param) {
            if (param == "id" && payload) {
                this.searchForm.id = payload;
                // this.searchForm.status = "0";
            } else if (param == "project_id" && payload) {
                this.searchForm.project_id = payload;
                // this.searchForm.status = "0";
            }
            page ? (this.paginationData.page = 1) : "";
            this.searchForm.appointor = this.appointor.toString();
            oaApi
                .job(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        orderby_id: this.orderby_id,
                        orderby_create_time: this.orderby_create_time,
                        orderby_priority: this.orderby_priority,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.statusList = res.ext.tabs;
                        /* this.$nextTick(() => {
                            this.resetTabActivePosition(this.$refs.tabs.$el);
                        }); */
                        this.tableData = res.data;
                        this.tableData.map(item=>{
                            item.completeVisible = false;
                        })
                        this.paginationData.total = res.total;
                        this.$refs.tableData.bodyWrapper.scrollTop = 0;
                        this.closeDrawer();
                        this.searchForm.id ? delete this.searchForm.id : "";
                    }
                });
        },

        resetTabActivePosition($el) {
            var activeEl = $el.querySelector(".el-tabs__item.is-active");
            //console.log(activeEl);
            var lineEl = $el.querySelector(".el-tabs__active-bar");
            if (activeEl) {
                var style = getComputedStyle(activeEl);
                var pl = style.paddingLeft.match(/\d+/)[0] * 1;
                var pr = style.paddingRight.match(/\d+/)[0] * 1;
                var w = style.width.match(/\d+/)[0] * 1;
                lineEl.style.transform =
                    "translateX(" + (activeEl.offsetLeft + pl) + "px)";
                lineEl.style.width = w - pl - pr + "px";
            }
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.job();
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            
            if (item.name == "查看") {
                this.detail(row);
            } else if (item.name == "编辑") {
                this.edit(row);
            } else if (item.name == "开始") {
                // this.$confirm(`确定${item.name}?`, "提示", {
                //     confirmButtonText: "确定",
                //     cancelButtonText: "取消",
                //     type: "warning",
                // })
                //     .then(() =>
                oaApi
                    .jobDetail({ job_id: row.id, status: "开始" }, "post")
                    .then((res) => {
                        //console.log(res);
                        if (res.code == 200) {
                            this.$message.success(`${item.name}成功`);
                            this.job();
                        }
                    });
                // )
                // .catch(() => {
                //     this.$message.info("已取消操作");
                // });
            } else if (item.name == "完成") {
                this.tableItem = row;
                this.completeVisible = true;
            } else if (item.name == "关闭") {
                this.jobUpdateStatus(item, row.id, 20);
            } else if (item.name == "取消") {
                this.jobUpdateStatus(item, row.id, 99);
            } else if (item.name == "删除") {
                oaApi.job({}, "delete", row.id).then((res) => {
                    if (res) {
                        if (res.code == 200) {
                            this.$message.success(`${item.name}成功`);
                            this.job();
                        }
                    }
                });
            }
        },
        edit(row) {
            this.tableItem = row;
            this.editVisible = true;
        },
        authFunc(funcName) {
            this[funcName]();
        },
        handleSelectionChange(val) {
            this.selectionUserIdList = [];
            for (let i in val) {
                this.selectionUserIdList.push(val[i].id);
            }
        },
        jobUpdateStatus(item, id, status) {
            // this.$confirm(`确定${item.name}?`, "提示", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     type: "warning",
            // })
            //     .then(() =>
            oaApi.jobUpdateStatus({ id, status }, "post").then((res) => {
                if (res) {
                    if (res.code == 200) {
                        this.$message.success(`${item.name}成功`);
                        this.job();
                    }
                }
            });
            // )
            // .catch(() => {
            //     this.$message.info("已取消操作");
            // });
        },
        getStaffSelect() {
            oaApi.select({}, "get").then((res) => {
                if (res) {
                    //console.log(res);
                    this.staffList = res.data;
                }
            });
        },
        /**
         * 获取项目下拉菜单
         */
        projectSelect() {
            oaApi.projectSelect({}, "get").then((res) => {
                if (res.code == 200) {
                    this.projectList = res.data;
                }
            });
        },
        sortChange(column) {
            if (column.prop == "id") {
                if (column.order == "descending") {
                    this.orderby_id = "desc";
                } else if (column.order == "ascending") {
                    this.orderby_id = "asc";
                } else if (column.order == null) {
                    this.orderby_id = null;
                }
            } else if (column.prop == "priority") {
                if (column.order == "descending") {
                    this.orderby_priority = "desc";
                } else if (column.order == "ascending") {
                    this.orderby_priority = "asc";
                } else if (column.order == null) {
                    this.orderby_priority = null;
                }
            } else if (column.prop == "create_time") {
                if (column.order == "descending") {
                    this.orderby_create_time = "desc";
                } else if (column.order == "ascending") {
                    this.orderby_create_time = "asc";
                } else if (column.order == null) {
                    this.orderby_create_time = null;
                }
            }
            this.job();
        },
        projectTeam(id) {
            if (!id) return;
            this.appointor = [];
            oaApi.projectTeam({ id }, "get").then((res) => {
                if (res) {
                    //console.log(res);
                    this.staffList = res.data;
                }
            });
            this.job();
        },
        projectClear() {
            this.getStaffSelect();
        },
        choiceAppointor(index) {
            this.activeIndex = index;
        },
        popoverShow(itemId){
            this.jobDetailTotalTime(itemId);
        },
        /**
         * 获取指派人总耗时
         */
        jobDetailTotalTime(itemId) {
            oaApi
                .jobDetailTotalTime({ job_id: this.tableItem.id || itemId }, "get")
                .then((res) => {
                    //console.log(res);
                    if (res.code == 200) {
                        this.total_time = res.data.hour;
                    }
                });
        },
    },
    created() {
        this.job();
    },
    activated() {
        this.getStaffSelect();
        this.projectSelect();
    },
    components: {
        pagination: pagination,
        advancedSearch: advancedSearch,
        popConfirm: popConfirm,
        jobAdd: () => import("./jobManagement/add.vue"),
        jobEdit: () => import("./jobManagement/edit.vue"),
        jobDetail: () => import("./jobManagement/detail.vue"),
        jobComplete: () => import("./jobManagement/complete.vue"),
    },
    watch: {
        perPage: {
            handler(newValue) {
                this.perPage = newValue;
                this.job();
            },
            deep: true,
            immediate: false,
        },
        page: {
            handler(newValue) {
                this.page = newValue;
                this.job();
            },
            deep: true,
            immediate: false,
        },
        $route: {
            handler: function (to, from) {
                if (to.name == "jobManagement" && to.query.id) {
                    this.job(1, to.query.id, "id");
                }
                if (to.name == "jobManagement" && to.query.project_id) {
                    this.job(1, to.query.project_id, "project_id");
                }
                /* if (to.name == "jobManagement") {
                    this.job(1, to.query.id || to.query.project_id, to.query.id ? "id":"project_id");
                } */
            },
            // 深度观察监听
            deep: true,
            immediate: true,
        },
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
    },
};
</script>
<style lang="scss">
.jobManagement {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .tableCont {
        // width: calc(100% - 250px);
        width: 100%;
        height: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        .table {
            width: 100%;
            // padding: 0 20px;
            // .el-scrollbar__wrap {
            //     overflow-x: hidden;
            // }
          .nameCont {
            display: flex;
            align-items: center;
            justify-content: start;
            .headImg {
              height: 28px;
              width: 28px;
              border-radius: 8px;
              overflow: hidden;
              margin-right: 8px;
              justify-items: flex-start;
              img{
                width: 100%;
              }
            }
            .memberName {
              line-height: 24px;
            }
          }
            .appointor_p {
                position: relative;
                right: 2px;
                padding: 3px 3px 3px 10px;
                border: 1px solid transparent;
                border-radius: 1px;
                &:hover {
                    border: 1px solid #c0c6cc;
                    i {
                        display: inline-block !important;
                    }
                }
                i {
                    position: absolute;
                    left: 5px;
                    top: 50%;
                    display: none;
                    transform: translateY(-50%);
                }
                &:active {
                    border-color: #303133;
                    color: #303133;
                }
            }
        }
    }
    // .el-scrollbar__wrap {
    //     overflow-x: hidden;
    // }
}
</style>
